import { Box } from '@mui/material';
import Output from 'components/Output';
import { GeneratedJobType, RegenerateFuncType } from './types';

type HiddenJobAdsProps = {
    item: GeneratedJobType | null;
    isGeneratingJob: boolean | undefined;
    regenerate: RegenerateFuncType;
};

export const HiddenJobAds = ({ item, isGeneratingJob, regenerate }: HiddenJobAdsProps) => {
    const maxNoOfCardsOnScreen = Math.floor(screen.width / 550);
    const hiddenMessages = item?.hiddenMessages
        ?.map((messageId) =>
            item.messages.find((item) => item.message_id === messageId && item.isHidden),
        )
        ?.filter((message) => message);
    const messagesLength = item?.messages?.filter((x) => !x.isHidden)?.length;
    const clsName = `hidden-cards ${
        item?.hiddenMessages && item?.hiddenMessages?.length > maxNoOfCardsOnScreen ? 'stacked' : ''
    }`;

    return (
        <Box className={clsName}>
            {hiddenMessages?.map((version) => {
                if (version) {
                    const versionClsName = `animate__animated animate__pulse item-${(
                        hiddenMessages?.indexOf(version) + 1
                    ).toString()}`;

                    return (
                        <Box key={version.message_id} className={versionClsName}>
                            <Output
                                item={version}
                                key={version.message_id}
                                streamingValue={version.content}
                                regenerate={regenerate}
                                isGeneratingJob={isGeneratingJob}
                                messages={item?.messages}
                                messagesLength={messagesLength}
                                hiddenMessages={item?.hiddenMessages ?? []}
                            />
                        </Box>
                    );
                }
            })}
        </Box>
    );
};
